import { useEffect, useState } from "react";
import { useApiData } from "../../contexts/ApiData";
import { useTranslations } from "../../contexts/Translation";
import { Comment } from "../../types";
import AiCoach from "../AiCoach/AiCoach";
import { fixNewlines } from "../../lib/text";
import styles from "./SidePanel.module.css";
import { coachImages, coachLabel } from "../Comments/coach";

type CoachCardProps = {
  surveyId: string;
  status?: string;
  canAskCoach?: boolean;
};

// The latest round: the coach comments after the last comment from a person, at most two.
const latestRound = (comments: Comment[]) => {
  const lastPerson = comments.map((c) => !c.isAiComment).lastIndexOf(true);
  return comments
    .slice(lastPerson + 1)
    .filter((c) => c.isAiComment)
    .slice(-2);
};

const CoachCard = ({ surveyId, status, canAskCoach }: CoachCardProps) => {
  const t = useTranslations("surveys");
  const tCoach = useTranslations("aiCoach");
  const { get } = useApiData();
  const [latest, setLatest] = useState<Comment[]>([]);

  useEffect(() => {
    const call = async () => {
      const comments: Comment[] | null = await get(`/comment/survey/${surveyId}`);
      setLatest(latestRound(comments || []));
    };
    call();
  }, [get, surveyId]);

  return (
    <section className={[styles.card, styles.dark].join(" ")} aria-labelledby='coach-heading'>
      <h2 id='coach-heading' className={styles.heading}>
        {t("coachHeading")}
      </h2>
      <div className={styles.coaches}>
        <img src='/assets/coach-rhys.jpg' alt='' width={48} height={48} />
        <img src='/assets/coach-lisa.jpg' alt='' width={48} height={48} />
        <span>{t("coachNames")}</span>
      </div>
      <p className={styles.text}>{tCoach("dataSources")}</p>
      {latest.map((comment) => (
        <blockquote key={comment.id} className={styles.coachComment} data-testid='coach-message'>
          <p>{fixNewlines(comment.content)}</p>
          <footer>
            {coachImages(comment).map((src) => (
              <img key={src} className={styles.coachPortrait} src={src} alt='' width={24} height={24} />
            ))}
            {coachLabel(comment, t)}
          </footer>
        </blockquote>
      ))}
      {status === "finished" && canAskCoach && (
        <AiCoach
          coachingType='surveyComment'
          surveyId={surveyId}
          variant='onDark'
          buttonLabel={t("askCoach")}
          onComplete={(result) => setLatest(Array.isArray(result) ? result : [result as Comment])}
        />
      )}
    </section>
  );
};

export default CoachCard;
